import { Directive } from '@angular/core';

@Directive({
  selector: 'ng-template[uiTableHeader]',
})
export class TableHeaderDirective {
}
